import { Link, useLocation } from 'react-router-dom';
import './header.scss';
import { useEffect, useState } from 'react';
import classNames from 'classnames';
import paths from '@/routes/paths';
import { ReactComponent as MainLogo } from '@/assets/icons/svg/common/main-logo.svg';
import { ReactComponent as InquiryArrow } from '@/assets/icons/svg/common/inquiry-arrow.svg';
import { ReactComponent as HambugerIcon } from '@/assets/icons/svg/common/hambuger.svg';
import useDeviceSize from '@/hooks/useDeviceSize';
import MobileMenu from './mobile-menu';
import { motion } from 'motion/react';
import { useRouter } from '@/hooks/useRouter';

export type menuListType = {
	id: number;
	label: string;
	path: string;
	subMenu?: { id: number; label: string; path: string }[];
	mobileSubMenu?: {
		id: number;
		label: string;
		path?: string;
		depsMenu?: { id: number; label: string; path: string }[];
	}[];
};

const menuList: menuListType[] = [
	{
		id: 1,
		label: '미스터디벨로 소개',
		path: '/intro',
		subMenu: [
			{
				id: 101,
				label: '미스터디벨로 철학',
				path: paths.intro.philosophy
			},
			// TODO: 작업 프로세스 페이지 추가 시 주석 해제
			// {
			// 	id: 102,
			// 	label: '작업 프로세스',
			// 	path: paths.intro.process
			// },
			{ id: 103, label: '턴키 개발이란', path: paths.intro.turnKey }
		]
	},
	{
		id: 2,
		label: '포트폴리오',
		path: paths.portfolio
	},
	{
		id: 3,
		label: '칼럼',
		path: paths.column
	},
	// TODO: 고객 후기 페이지 삭제됨. 페이지 삭제후 주석 삭제
	// {
	// 	id: 4,
	// 	label: '고객 후기',
	// 	path: paths.review
	// },
	{
		id: 5,
		label: 'FAQ',
		path: paths.faq
	}
];

type Props = {
	isLandingPage?: boolean;
};
const Header = ({ isLandingPage = false }: Props) => {
	const { deviceSize } = useDeviceSize({
		mobile: 815
	});
	const [_isScrolled, setIsScrolled] = useState(false);
	const [isPcMenuOpen, setIsPcMenuOpen] = useState(false);
	const location = useLocation();
	const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
	// 랜딩 페이지가 아니면 항상 스크롤 상태를 true로 설정
	const isScrolled = isLandingPage ? _isScrolled : true;

	const router = useRouter();

	useEffect(() => {
		if (!isLandingPage) return;

		// 스크롤 이벤트 리스너 추가
		const handleScroll = () => {
			const scrollPosition = window.scrollY;
			// 스크롤이 0이면 false, 아니면 true
			setIsScrolled(scrollPosition > 0);
		};

		window.addEventListener('scroll', handleScroll);
		// 초기값 설정
		handleScroll();

		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, [isLandingPage]);

	useEffect(() => {
		setIsPcMenuOpen(false);
	}, [location]);

	return (
		<nav
			className={classNames('header-root', {
				scrolled: isScrolled
			})}
		>
			{isPcMenuOpen && (
				<div
					className="header-pc-menu-box"
					onMouseEnter={() => setIsPcMenuOpen(true)}
					onMouseLeave={() => setIsPcMenuOpen(false)}
				/>
			)}
			<section className="header-inner-wrapper">
				<Link
					to={paths.home}
					className="header-logo"
					aria-label="미스터디벨로 홈으로 이동"
				>
					<MainLogo
						className={classNames('header-logo-icon', {
							scrolled: isScrolled
						})}
					/>
				</Link>

				<nav
					className={classNames('landing-menu-box', {
						scrolled: isScrolled
					})}
				>
					{/* ----------------여기부터 데스크탑+태블릿 메뉴 ---------------- */}

					{deviceSize !== 'mobile' && (
						<ul className="menu-list">
							{menuList.map((menu) => {
								// 현재 경로가 상위 메뉴 경로로 시작하는지 확인 (예: /intro/*)
								const isActive =
									location.pathname === menu.path ||
									(location.pathname.startsWith(menu.path) &&
										menu.path !== '/');

								const handleClickMenu = (string: string) => {
									router.push(string);
								};

								return (
									<li
										key={menu.id}
										className={classNames('menu-item', {
											active: isActive,
											scrolled: isScrolled,
											'hover-effect':
												isPcMenuOpen && menu.id === 1
										})}
										{...(menu.id === 1 && {
											onMouseEnter: () =>
												setIsPcMenuOpen(true),
											onMouseLeave: () =>
												setIsPcMenuOpen(false)
										})}
									>
										<p
											className="text-link"
											onClick={() => {
												if (menu.subMenu) {
													setIsPcMenuOpen(
														!isPcMenuOpen
													);
													return;
												}
												handleClickMenu(menu.path);
											}}
										>
											{menu.label}
										</p>
										<div
											className="menu-item-underline"
											{...(menu.id === 1 && {
												onMouseEnter: () =>
													setIsPcMenuOpen(true),
												onMouseLeave: () => {}
												// setIsPcMenuOpen(false)
											})}
										/>{' '}
										{menu.subMenu && (
											<div
												className={classNames(
													'sub-menu-box',
													{
														open: isPcMenuOpen
													}
												)}
											>
												<ul
													className={classNames(
														'sub-menu-list',
														{
															open: isPcMenuOpen
														}
													)}
												>
													{menu.subMenu.map(
														(subMenu) => {
															const isSubActive =
																location.pathname ===
																subMenu.path;

															return (
																<li
																	key={
																		subMenu.id
																	}
																	className={classNames(
																		'sub-menu-item',
																		{
																			active: isSubActive,
																			scrolled:
																				isScrolled
																		}
																	)}
																>
																	<Link
																		to={
																			subMenu.path
																		}
																	>
																		{
																			subMenu.label
																		}
																	</Link>
																</li>
															);
														}
													)}
												</ul>
											</div>
										)}
									</li>
								);
							})}
						</ul>
					)}

					{/* ----------------여기까지 데스크탑+태블릿 메뉴 ---------------- */}
					<Link
						to={paths.inquiry}
						className={classNames('inquiry-button', {
							scrolled: isScrolled
						})}
					>
						<p>문의하기</p>
						<InquiryArrow
							className={classNames('inquiry-arrow', {
								scrolled: isScrolled
							})}
						/>
					</Link>
					{deviceSize === 'mobile' && (
						<div
							className="hambuger-menu-box"
							onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
						>
							<HambugerIcon
								className={classNames('hambuger-icon', {
									open: mobileMenuOpen
								})}
							/>
						</div>
					)}
				</nav>
			</section>
			<MobileMenu
				mobileMenuOpen={mobileMenuOpen}
				setMobileMenuOpen={setMobileMenuOpen}
				menuList={menuList}
			/>
		</nav>
	);
};

export default Header;
